import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from 'chart.js';

interface PieGraphicProps {
  title: string;
  arrayName: Array<string>;
  arrayNumber: Array<number>;
}

ChartJS.register(ArcElement, Tooltip, Legend, Title);

const PieGraphic = (props: PieGraphicProps) => {
  const { title, arrayName, arrayNumber } = props;

  const dataFactory = () => {
    let labels: Array<string> = [];
    let data: Array<number | string> = [];
    let backgroundColor: Array<string> = [];
    let borderColor: Array<string> = [];
    labels = arrayName;
    data = arrayNumber;
    backgroundColor = [
      'rgba(210, 51, 81, 1)',
      'rgba(40, 167, 69, 1)',
      'rgba(149, 108, 202, 1)',
      'rgba(253, 161, 23, 1)',
      'rgba(37, 171, 201, 1)',
      'rgba(73, 119, 208, 1)',
    ];
    borderColor = ['rgba(255, 255, 255, 1)'];

    return {
      datasets: [
        {
          data,
          backgroundColor,
          borderColor,
          borderWidth: 2,
          showTooltips: false,
        },
      ],
      labels,
      fillStyle: '#000',
    };
  };

  const PieOptions = {
    maintainAspectRatio: false,
    plugins: {
      title: {
        align: 'start' as 'start',
        display: true,
        text: title,
        padding: {
          top: 10,
          bottom: 20,
        },
        color: '#000000',
        font: { weight: 'bold' },
      },
      legend: {
        display: true,
        position: 'bottom' as 'bottom',
      },
    },
  };
  return (
    <div className="card p-3" style={{ height: ' 350px' }}>
      <Pie data={dataFactory()} options={PieOptions} />
    </div>
  );
};

export default PieGraphic;
